module.exports = __webpack_public_path__ + "media/images/Logo-Moovejob-231616179b5366fd165a3f9860b4b864.svg";